import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { api } from '../api';

function Subscribers() {
  const navigate = useNavigate();
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const fetchSubscribers = async (pageNum = page, limitNum = perPage) => {
    setLoading(true);
    setError(null);
    const res = await api.getSubscribers(pageNum, limitNum);
    if (!res) {
      setError('Failed to load subscribers');
      setSubscribers([]);
      setTotalRows(0);
    } else {
      setSubscribers((res.subscribers || []).map(item => ({
        id: item.id,
        email: item.email || '-',
        createdAt: item.createdAt || null,
      })));
      setTotalRows(res.total || 0);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSubscribers(page, perPage);
    // eslint-disable-next-line
  }, [page, perPage]);

  const handlePageChange = pageNum => setPage(pageNum);
  const handlePerRowsChange = async (newPerPage, pageNum) => {
    setPerPage(newPerPage);
    setPage(pageNum);
  };

  const columns = [
    {
      name: 'Profile',
      selector: row => <img className="vendor-thumb" src={'/assets/img/vendor/u9.jpg'} alt="subscriber profile" />, width: '80px',
    },
    { name: 'Email', selector: row => row.email, sortable: true },
    { name: 'Join On', selector: row => row.createdAt ? new Date(row.createdAt).toLocaleDateString() : '-', sortable: true },
    {
      name: 'Action',
      cell: row => (
        <div className="btn-group mb-1">
          <button type="button" className="btn btn-outline-success" onClick={() => navigate(`/subscribers/${row.id}`)}>Info</button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Subscribers | Owena Admin Dashboard</title>
      </Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Subscribers</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e) => e.preventDefault()}>Home</a></span>
                <span><i className="mdi mdi-chevron-right"></i></span>Subscribers</p>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  {error && <div className="alert alert-danger">{error}</div>}
                  <DataTable
                    columns={columns}
                    data={subscribers}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    highlightOnHover
                    responsive
                    noHeader
                  />
                </div>
              </div>
            </div>
          </div>

          {/* The add/edit subscriber modals were removed to align with Customers page UX under User Management */}
        </div>
      </div>
    </>
  );
}

export default Subscribers;
